$(function () {
    var $currentForm = $('#form_' + pool.controller);
    // copy from jquery.form.js
    if (
        $currentForm.length < 1 ||
        $currentForm.get(0).tagName === undefined ||
        $currentForm.get(0).tagName.toLowerCase() !== 'form'
    ) {
        return;
    }
    // init alcedisForm for valid form tag (multiple form check in jquery.form.js line: 81)
    $currentForm.alcedisForm({
        language:     pool.language,
        application:  pool.application,
        controller:   pool.controller,
        id:           pool.id,
        params:       pool.params,
        harass:       true,
        beforeSubmit: function ($form) {
            $('.buttons button.delete', $form).click(function() {
                $form.holdValidations();

                var i18n            = pool.i18n.rec_js;
                var reasonMandatory = pool.reasonMandatory;
                var $deleteDialogContent = $(
                      '<div class="delete-dialog">'
                    +     '<div class="question">'
                    +         i18n.delete_text
                    +     '</div>'
                    +     '<div class="buttons center-buttons">'
                    +         '<button class="delete">' + i18n.delete_btn_delete + '</button>'
                    +         '<button class="cancel do_not_harass">' + i18n.delete_btn_cancel + '</button>'
                    +     '</div>'
                    + '</div>'
                );

                if (reasonMandatory === true) {
                    var $deleteReasonForm = $(
                          '<div class="delete_reason_form">'
                        +     '<span class="reason_label">' + i18n.delete_reason + '</span>'
                        +     '<div class="delete_reason_container">'
                        +         '<textarea name="delete_reason" class="delete_reason" />'
                        +     '</div>'
                        + '</div>'
                    );

                    $deleteDialogContent.find('div.question').after($deleteReasonForm);

                    var $deleteReason = $deleteDialogContent.find('textarea.delete_reason').focus();
                }

                $deleteDialogContent.find('button.cancel').afButton().click(function () {
                    $deleteDialogContent.dialog('close');
                });

                $deleteDialogContent.find('button.delete').afButton().click(function () {
                    $form.buildSubmitUrl('delete');

                    if (reasonMandatory === true) {
                        $form.submit(
                            {name: '_delete_reason', value: $deleteReason.val()}
                        );

                        $deleteReason.focus();
                    } else {
                        $form.submit();
                    }
                });

                $deleteDialogContent.dialog({
                    title: i18n.delete_title,
                    width: 360,
                    minHeight: 50,
                    modal: true
                });

                return false;
            });

            $('.buttons button:not(.delete)', $form).click(function() {
                var action = $(this).attr('class').split(' ').shift(); // not good
                var stay = $(this).hasClass(action + 'AndStay');
                $form.holdValidations();
                $form.buildSubmitUrl(action, undefined, stay);
            });
        }
    }).init();
});
